var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"error-page"},[_c('div',{staticClass:"error-page__content has-text-centered"},[_c('p',{staticClass:"error-page__code"},[_vm._v("\n      "+_vm._s(_vm.statusCode)+"\n    ")]),_vm._v(" "),_c('h1',{staticClass:"title is-3"},[_vm._v("\n      "+_vm._s(_vm.$t('errorPage.title'))+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"subtitle is-5"},[_vm._v("\n      "+_vm._s(_vm.$t('errorPage.description'))+"\n    ")]),_vm._v(" "),_c('nuxt-link',{staticClass:"button is-primary is-medium is-rounded",attrs:{"to":_vm.localePath({
        name: 'product',
        params: {
          productName: 'plissee-ohne-bohren',
          productId: 10,
        },
      })}},[_vm._v("\n      "+_vm._s(_vm.$t('errorPage.plisses'))+"\n    ")]),_vm._v(" "),_c('nuxt-link',{staticClass:"button is-primary is-medium is-rounded",attrs:{"to":_vm.localePath({
        name: 'product',
        params: {
          productName: 'schuette-wabenplissee-verdunklungsplissee-ohne-bohren-nach-mas-blackout-x-honey-moonlight-weis',
          productId: 10948,
        },
      })}},[_vm._v("\n      "+_vm._s(_vm.$t('errorPage.honeycomb'))+"\n    ")]),_vm._v(" "),_c('nuxt-link',{staticClass:"button is-primary is-medium is-rounded",attrs:{"to":_vm.localePath({
        name: 'product',
        params: {
          productName: 'schuette-verdunkelungsrollo-ohne-bohren-mit-bohren-2in1-nach-mas-kollektion-thermo-blackout-snowflake',
          productId: 2147,
        },
      })}},[_vm._v("\n      "+_vm._s(_vm.$t('errorPage.blackout'))+"\n    ")]),_vm._v(" "),_c('nuxt-link',{staticClass:"button is-primary is-medium is-rounded",attrs:{"to":_vm.localePath({
        name: 'product',
        params: {
          productName: 'schuette-spannbettlaken-140-x-200-wow-kollektion-fluff-white-weis-100-superfluff-baumwolle',
          productId: 66843,
        },
      })}},[_vm._v("\n      "+_vm._s(_vm.$t('errorPage.fitted'))+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }